export default
{
    name: 'app-btn',

    props:
    {
        selected: { type: Boolean, default: false },
        to: { type: String, default: '' },
        type: { type: String },
        target: { type: String, default: '_blank' }
    },

    methods:
    {
        _onMouseClick(event)
        {
            if (this.to && (!this.to.includes('mailto:') && !this.to.includes('http')))
            {
                this.$root.changePage(this.to)
            }
            else if (this.to.includes('mailto:') || (this.to.includes('http') && this.target !== '_blank'))
            {
                window.open(this.to, this.target)
            }
            else if (this.to.includes('http'))
            {
                window.open(this.to, this.target)
            }

            this.$emit('click', event)
        },

        _onMouseEnter(event)
        {
            this.$el.classList.add('is-hovered')
        },

        _onMouseLeave(event)
        {
            this.$el.classList.remove('is-hovered')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-btn/script.js